/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
$('.product-owl').owlCarousel({
    loop:false,
  	center: true,
  	stagePadding: 0,
  	items: 1,
    margin: 10,
    nav:false,
  	dots:true
    
})

$('.rtd-test').change(function(){
  var i = false;

   setTimeout(function(){
      var varient_id = getUrlParameter('variant');
      $('.mobile-f-section.m-hide-show .owl-stage .owl-item').each(function(){
          var img_variant = $(this).find('img[data-variant-id]').attr('data-variant-id');
		  if(img_variant == varient_id){
            i=true;
            $(this).find('img[data-variant-id]').parent().parent().parent().addClass('active');
			var imgInd = $(this).find('img[data-variant-id]').parent().parent().parent().index();
            $('.mobile-f-section.m-hide-show .owl-dot').each(function(){
              if(imgInd == $(this).index()){
              	$(this).trigger('click');
              }
            })
          }
        if(!i){
          $(this).find('img[data-variant-id]').parent().parent().parent().removeClass('active');
        }
      })
      
      //Extend dispatch event to extend-product-integration
      window.dispatchEvent(Extend.CustomEvent('variantChange'))
      //Extend - end code
      
   },100);
});
var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};